import { useState } from "react";
import {
  PARTICIPANT_STATUS_CONFIG,
  getParticipantStatusLabel,
  getStatusLabel,
  getUserInitials,
} from "../../../utils";

/**
 * Props :
 * - participant
 * - isCurrentUser
 * - canManageStatuses (boolean)  ← enseignant / admin
 * - onStatusChange
 * - onRemove
 */
export default function ParticipantRow({
  participant,
  isCurrentUser,
  canManageStatuses,
  onStatusChange,
  onRemove,
}) {
  const user = participant.users;
  const [showAllStatuses, setShowAllStatuses] = useState(false);

  const QUICK_STATUSES = ["present", "cancelled"];

  const handleStatusClick = (status) => {
    onStatusChange(participant.user_id, status);
    setShowAllStatuses(false); // UX améliorée : repli automatique
  };

  return (
    <div className="participant-row">
      {/* INFO */}
      <div className="participant-info">
        <div className="participant-avatar">{getUserInitials(user)}</div>
        <div>
          {user?.first_name} {user?.last_name}
          {isCurrentUser && <span className="badge-you">Vous</span>}
          <div className="participant-status-label">
            {getParticipantStatusLabel(participant.status)}
          </div>
        </div>
      </div>

      {/* ACTIONS */}
      <div
        className={`participant-actions ${showAllStatuses ? "expanded" : ""}`}
      >
        {/* STATUTS RAPIDES */}
        {Object.entries(PARTICIPANT_STATUS_CONFIG)
          .filter(([status]) => QUICK_STATUSES.includes(status))
          .map(([status, { icon: StatusIcon, label }]) => (
            <button
              key={status}
              type="button"
              className={`btn-icon-modern btn-status ${
                participant.status === status ? "active" : ""
              }`}
              onClick={() => handleStatusClick(status)}
              title={label}
              aria-label={label}
            >
              <StatusIcon />
            </button>
          ))}

        {/* MORE (enseignants uniquement) */}
        {canManageStatuses && !showAllStatuses && (
          <button
            type="button"
            className="btn-icon-modern btn-status btn-more"
            onClick={() => setShowAllStatuses(true)}
            title="Autres statuts"
            aria-label="Autres statuts"
          >
            ⋯
          </button>
        )}

        {/* STATUTS SECONDAIRES */}
        {showAllStatuses &&
          Object.entries(PARTICIPANT_STATUS_CONFIG)
            .filter(([status]) => !QUICK_STATUSES.includes(status))
            .map(([status, { icon: StatusIcon, label }]) => (
              <button
                key={status}
                type="button"
                className={`btn-icon-modern btn-status ${
                  participant.status === status ? "active" : ""
                }`}
                onClick={() => handleStatusClick(status)}
                title={label}
                aria-label={label}
              >
                <StatusIcon />
              </button>
            ))}
      </div>
    </div>
  );
}
